module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola_link_image_flow-5bd523cbcfeda961abf4cd424f9cf9d1.jpg";